import React from 'react';
import Typography from '@mui/material/Typography';

interface ToolCallReasonProps {
  reason?: string;
}

const ToolCallReason: React.FC<ToolCallReasonProps> = ({ reason }) => {
  if (!reason) {
    return null;
  }

  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        fontSize: '0.72rem',
        lineHeight: 1.35,
        mt: 0.15,
      }}
    >
      {reason}
    </Typography>
  );
};

export default ToolCallReason;
